import request from '@/utils/request'

export function getConfig(path) {
  path = decodeURIComponent(path)
  return request({
    url: path,
    method: 'get'
  })
}

export function getTabConfig(path) {
  path = decodeURIComponent(path)
  return request({
    url: path,
    method: 'get'
  })
}

export function checkSession(path) {
  return request({
    url: path,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js